import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const QuantityTranslations = wrapTranslationsSchema({
	name: 'QuantityTranslations',
	title: 'Quantity Translations',
	sanityId: 'quantity',
	fields: {
		validationMinExceedsMax: 'Min exceeds max',
		validationInvalidQuantity: 'Invalid quantity',
		validationMaxAllowed: 'Maximum allowed: {max}',
		validationMinAllowed: 'Minimum allowed: {min}',
		validationRequiredQuantity: 'Required quantity: {quantity}',
	},
});
